import {
  KibBoxIcon as OrdersIcon,
  KibTruckIcon as ShippingIcon,
  KibChewyMonoIcon as AccountIcon,
  KibChewyPlusMonoIcon as LoyaltyIcon,
  KibChewyPlusIcon as ChewyPlusIcon,
  KibPharmacyIcon as RXIcon,
  KibHealthCareIcon as HealthServiceIcon,
  KibAutoshipMonoIcon as AutoshipIcon,
  KibHouseShelterIcon as GiveBackIcon,
  KibEmailFillIcon as EmailIcon,
  KibConnectWithAVetPersonIcon as VetChatIcon,
  KibTagIcon,
  KibCallIcon,
  KibChatFillIcon
} from '@chewy/kib-icons-react';

import styles from '@/components/helpCenter/common/iconLink.module.scss';
import React from 'react';

import GreenIcon from '@/components/icons/greenIcon.svg';
import FishIcon from '@/components/icons/help-home-fish.svg';
import CatIcon from '@/components/icons/help-home-cat-yarn.svg';
import ChewyPlusesIcon from '@/components/icons/help-home-chewy.svg';
import ChameleonIcon from '@/components/icons/help-home-chameleon.svg';
import GetRealIcon from '@/components/icons/get-real-icon.svg';
import GetRealIconNew from '@/components/icons/get-real-icon-new.svg';
import ReturnsIcon from '@/components/icons/returns.svg';
import ReturnsIconNew from '@/components/icons/returns-icon-new.svg';
import GiveBackIconNew from '@/components/icons/give-back-icon-new.svg';
import DogBirdIcon from '@/components/icons/orders-payments-promos-dog-bird.svg';
import HighFiveIcon from '@/components/icons/account-high-five.svg';
import PrescriptionsCatIcon from '@/components/icons/prescriptions-cat.svg';
import HealthServicesDogIcon from '@/components/icons/health-services-dog.svg';
import GetRealPageIcon from '@/components/icons/rx-meds.svg';
import PaymentDogCCIcon from '@/components/icons/payment-dog-cc.svg';
import PrescriptionDietWaiterIcon from '@/components/icons/prescription-diet-waiter.svg';
import HealthServicesCVCIcon from '@/components/icons/health-services-cvc.svg';

import ShippingTrackingDogIcon   from '@/components/icons/shipping-tracking-illo.svg';
import AutoshipBalloonIcon from '@/components/icons/autoship-illo.svg';
import ChewyPlusBoxIcon from '@/components/icons/chewy-illo.svg';
import ReturnsCatBreadIcon from '@/components/icons/returns-illo.svg';
import RescuresAndSheltersCatBoxIcon from '@/components/icons/rescues-shelters-illo.svg';
import HCChatIcon from '@/components/icons/hc-chat-icon.svg';

import { isEmpty, isNil, find, toNumber } from 'lodash';
import URLGenerator from './URLGenerator';
import { DEFAULT_OHC_CATEGORY_IDS_MAP } from './constants';

export function getTopicIcon(key) {
  switch (key) {
    case 'OrdersIcon':
      return <OrdersIcon />;
    case 'ShippingIcon':
      return <ShippingIcon />;
    case 'AccountIcon':
      return <AccountIcon />;
    case 'AutoshipIcon':
      return <AutoshipIcon />;
    case 'LoyaltyIcon':
      return <ChewyPlusIcon/>;
    case 'HealthServiceIcon':
      return <HealthServiceIcon />;
    case 'GiveBackIcon':
      return <GiveBackIconNew/>;
    case 'PrescriptionsIcon':
      return <RXIcon />;
    case 'ReturnsIcon':
      return <ReturnsIconNew />;
    case 'TagIcon':
      return <KibTagIcon />;
    case 'ChatIcon':
      return <KibChatFillIcon />;
    case 'HCChatIcon':
        return <HCChatIcon />;  
    case 'CallIcon':
      return <KibCallIcon />;
    case 'GreenIcon':
      return <GreenIcon />;
    case 'EmailIcon':
      return <EmailIcon />;
    case 'VetChatIcon':
      return <VetChatIcon />; // Assuming 'VetChatIcon' uses the same icon as 'ChatIcon'
    case 'GetRealIcon':
      return <GetRealIconNew />;
    default:
      return null; // Or a default icon
  }
}

export const isRXTopicSelected = (categoryId, categoryIds) => {
  if (!categoryId || !categoryIds) {
    return false;
  }
  return toNumber(categoryId) === categoryIds?.['prescriptions'];
}

export const getTopicIconByID = (id, categoryIds) => {

  if (!id || !categoryIds) {
    return null;
  }



  switch (toNumber(id)) {
    case categoryIds?.['orders-payments-and-promotions']:
      return { start: <OrdersIcon/>, end: null, page: <DogBirdIcon className={styles.pageIcon} /> };
    case categoryIds?.['shipping-and-tracking']:
      return { start: <ShippingIcon />, end: <FishIcon className={styles.fishIcon} />, page: <ShippingTrackingDogIcon className={styles.pageIcon} /> };
    case categoryIds?.['account']:
      return { start: <AccountIcon />, end: <CatIcon className={styles.catIcon} />, page: <HighFiveIcon className={styles.pageIcon} /> };
      case categoryIds?.['autoship']:
      return { start: <AutoshipIcon />, end: null, page: <AutoshipBalloonIcon className={styles.pageIcon} /> };
    case categoryIds?.['chewy']:
      return { start: <ChewyPlusIcon />, end: <ChewyPlusesIcon className={styles.chewyPlusesIcon} />, page: <ChewyPlusBoxIcon className={styles.pageIcon} /> };
    case categoryIds?.['health-services']:
      return { start: <HealthServiceIcon />, end: <ChameleonIcon className={styles.chameleonIcon} />, page: <HealthServicesDogIcon className={styles.pageIcon} /> };
    case categoryIds?.['give-back']:
      return { start: <GiveBackIconNew />, end: null, page: <RescuresAndSheltersCatBoxIcon className={styles.pageIcon} /> };
    case categoryIds?.['prescriptions']:
      return { start: <RXIcon />, end: null, page: <PrescriptionsCatIcon className={styles.pageIcon} /> };
    case categoryIds?.['returns']:
      return { start: <ReturnsIconNew />, end: null, page: <ReturnsCatBreadIcon className={styles.pageIcon} /> };
    case categoryIds?.['get-real']:
      return { start: <GetRealIconNew />, end: null, page: <GetRealPageIcon className={styles.pageIcon} /> };
    case categoryIds?.['payments']:
      return { start: null, end: <PaymentDogCCIcon className={styles.paymentDogCCIcon} />, page: null };
    case categoryIds?.['managing-prescriptions-and-veterinary-diets']:
      return { start: null, end: <PrescriptionDietWaiterIcon className={styles.prescriptionDietWaiterIcon} />, page: null };
    case categoryIds?.['chewy-vet-care']:
      return { start: null, end: <HealthServicesCVCIcon className={styles.healthServicesCVCIcon} />, page: null };
    case 'tag':
      return { start: <KibTagIcon />, end: null, page: null };
    case 'chat':
      return { start: <KibChatFillIcon />, end: null, page: null };
    case 'call':
      return { start: <KibCallIcon />, end: null, page: null };
    case 'green':
      return { start: <GreenIcon />, end: null, page: null };
    case 'email':
      return { start: <EmailIcon />, end: null, page: null };
    default:
      return null; // Or a default icon
  }
};

export const findTopicsByID = (data, id) => {
  if (isEmpty(data) || isNil(id) || isEmpty(id)) {
    return null;
  }

  const objIds = id.split('/');
  const splitCount = objIds.length;

  if (isEmpty(objIds)) {
    return null;
  }

  const topic = objIds[0] ? find(data, topicObj => topicObj.id === objIds[0]) : null;
  const section = objIds[1] ? find(topic?.sections, topicObj => topicObj.id === `${objIds[0]}/${objIds[1]}`) : null;
  const article = objIds[2] ? find(section?.sections, topicObj => topicObj.id === `${objIds[0]}/${objIds[1]}/${objIds[2]}`) : null;

  let isError = false;

  if (splitCount === 1 && !topic) {
    isError = true;
  } else if (splitCount === 2 && !section) {
    isError = true;
  } else if (splitCount === 3 && !article) {
    isError = true;
  }

  return {
    topic,
    section,
    article,
    isError
  };
};

export const navigateToArticle = (id, router) => {
  const basePath = window.location.pathname.includes('/csrb/nma') ? '/csrb/nma/customer-care' : '/customer-care';
  const urlGenerator = new URLGenerator(basePath);

  if (!id) {
    router.push(urlGenerator.generateURL());
    return;
  }

  // This is the special case where a session already exists.  In this case
  // we only send the sessionId because all necessary information
  // has already been persisted
  urlGenerator.addSection({ value: id });

  const url = urlGenerator.generateURL();
  window.history.replaceState(null, '', url);
};

export const navigateToAnchor = (id, router) => {
  const urlGenerator = new URLGenerator('/customer-care');

  if (!id) {
    router.push(urlGenerator.generateURL());
    return;
  }

  // This is the special case where a session already exists.  In this case
  // we only send the sessionId because all necessary information
  // has already been persisted
  urlGenerator.addSection({ value: id });

  const url = urlGenerator.generateURL();
  router.push(url);
};

export const navigateToSearchResults = (query, router) => {
  const urlGenerator = new URLGenerator('/customer-care');

  if (!query) {
    router.push(urlGenerator.generateURL());
    return;
  }

  urlGenerator.addParameter({ name: 'searchQuery', value: query });

  const url = urlGenerator.generateURL();
  router.push(url);
};

export const navigateToLink = (link, router) => {
  if (!link) {
    return;
  }

  router.push(link);
};
